(() => {
  const initialized = new WeakSet();

  const numberValue = (input, fallback) => {
    const value = Number.parseFloat(String(input.value || '').replace(',', '.'));
    return Number.isFinite(value) ? value : fallback;
  };

  const initialize = (root) => {
    if (initialized.has(root)) return;
    const minRange = root.querySelector('[data-price-range-min]');
    const maxRange = root.querySelector('[data-price-range-max]');
    const minInput = root.querySelector('[data-price-input-min]');
    const maxInput = root.querySelector('[data-price-input-max]');
    const slider = root.querySelector('.facet-price__slider');
    if (!minRange || !maxRange || !minInput || !maxInput || !slider) return;

    initialized.add(root);
    const limit = Number.parseFloat(maxRange.max) || 0;

    const paint = () => {
      const min = numberValue(minRange, 0);
      const max = numberValue(maxRange, limit);
      slider.style.setProperty('--price-min-position', `${limit ? (min / limit) * 100 : 0}%`);
      slider.style.setProperty('--price-max-position', `${limit ? (max / limit) * 100 : 100}%`);
    };

    const syncFromRanges = (changed) => {
      let min = numberValue(minRange, 0);
      let max = numberValue(maxRange, limit);
      if (min > max) {
        if (changed === minRange) min = max;
        else max = min;
      }
      minRange.value = min;
      maxRange.value = max;
      minInput.value = min > 0 ? min.toFixed(2).replace(/\.00$/, '') : '';
      maxInput.value = max < limit ? max.toFixed(2).replace(/\.00$/, '') : '';
      paint();
      (changed === minRange ? minInput : maxInput).dispatchEvent(new Event('input', { bubbles: true }));
    };

    const syncFromInputs = () => {
      let min = numberValue(minInput, 0);
      let max = numberValue(maxInput, limit);
      min = Math.max(0, Math.min(min, limit));
      max = Math.max(min, Math.min(max, limit));
      minRange.value = min;
      maxRange.value = max;
      paint();
    };

    minRange.addEventListener('input', () => syncFromRanges(minRange));
    maxRange.addEventListener('input', () => syncFromRanges(maxRange));
    minInput.addEventListener('input', syncFromInputs);
    maxInput.addEventListener('input', syncFromInputs);
    syncFromInputs();
  };

  const initializeAll = (scope = document) => scope.querySelectorAll('[data-dual-price]').forEach(initialize);
  document.addEventListener('DOMContentLoaded', () => initializeAll());
  new MutationObserver((mutations) => {
    mutations.forEach(({ addedNodes }) => addedNodes.forEach((node) => {
      if (!(node instanceof Element)) return;
      if (node.matches('[data-dual-price]')) initialize(node);
      initializeAll(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
